import './ErrorForm.css'

export function ErrorForm() {
  return <span className="mensagemErro">Campo obrigatório</span>
}
